export default __webpack_public_path__ + "static/element_solutions_mob-0f6221bb317fc73c2d014a110a013f9c.png";